<template lang="pug">
  section(class="separable")
    div(class="container")
      el-row
        el-col(:span="24")
          div(class="card")
            div(class="card-header") {{ titulo }}
              .button
                app-button(
                  titulo="Novo Cadastro",
                  tipo="success",
                  method="goTo",
                  @goTo="goTo()",
                  icone="fa fa-plus"
                )
            div(class="card-body")
              el-table(:data="cadastros",
                class="full-width",
                v-loading="loading",
                element-loading-text="Carregando..."
              )
                template(slot="empty")
                  | Não há registros.
                el-table-column(
                  prop="interessado.pessoa.nome",
                  label="Nome/Razão Social do Interessado"
                  :formatter="formatNome"
                )
                el-table-column(
                  prop="interessado.pessoa.cpf",
                  label="CPF/CNPJ do Interessado",
                  :formatter="formatCpfCnpj"
                )
                el-table-column(
                  prop="cadastrante.pessoa.nome",
                  label="Nome/Razão Social do Cadastrante"
                  :formatter="formatNome"
                )
                el-table-column(
                  label="Data de atualização",
                  width="160",
                  :formatter="setData",
                )
                el-table-column(
                  label="Ações",
                  width="110",
                  align="center"
                )
                  template(slot-scope="scope")
                    div(v-if="!scope.row.finalizado")
                      el-tooltip(class="item", effect="dark",
                        content="Continuar", placement="left",
                      )
                        el-button(
                          type="text",
                          class = "edit",
                          @click="continuar(scope.row)",
                          size="mini"
                        )
                          i(class="fa fa-pencil-alt")

                      el-tooltip(class="item",
                        effect="dark", content="Remover",
                        placement="right"
                      )
                        el-button(
                          type="text",
                          class = "remove",
                          @click="remove(scope.row)",
                          size="mini"
                        )
                          i(class="fa fa-times")

                    div(v-if="scope.row.finalizado")
                      el-tooltip(class="item", effect="dark",
                        content="Enviar cadastro", placement="left",
                      )
                        el-button(
                          type="text",
                          size="mini",
                          :disabled="scope.row.exportado"
                          @click="exporta(scope.row)",
                          :title="scope.row.exportado ? 'Cadastro já foi exportado.' : 'exportar'"
                        )
                          i(class="far fa-file-upload")

                      el-tooltip(class="item",
                        effect="dark", content="Remover",
                        placement="right"
                      )
                        el-button(
                          type="text",
                          class = "remove",
                          @click="remove(scope.row)",
                          size="mini"
                        )
                          i(class="fa fa-times")

              br
              div.pagination
                el-pagination(
                  :page-size="pageSize",
                  @current-change="changePage()",
                  :current-page.sync="page",
                  layout="prev, pager, next",
                  :total="totalItems"
                )
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import AppActionButton from '@/components/AppActionButton'
import AppButton from '@/components/AppButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppButton,
    AppActionButton
  },
  mixins: [
    AppNotificacao
  ],
  props: {
    modulo: {
      type: String,
      required: true
    },
    method: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      default: 'Listagem de cadastros'
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      pageSize: 10,
      page: 1
    }
  },

  mounted () {
    // Setar mensagem para null ao clicar em logout para sair sem aparecer mensagem;
    this.setMensagemLogoutNull()
  },
  computed: {
    cadastros () {
      return this.$store.getters['listagem/items']
    },
    totalItems () {
      return this.$store.getters['listagem/totalItems']
    }
  },
  methods: {
    // Função para acessar o action do arquivo no Vuex 'listagem'
    ...mapActions({
      setMensagemLogoutNull: 'login/setMensagemLogoutNull'
    }),
    changePage () {
      return this.$emit('changePage', { newPage: this.page })
    },
    goTo () {
      this.$emit(this.method)
    },
    formatCpfCnpj (row, column, prop) {
      return prop || '-'
    },
    formatNome (row, column, prop) {
      return prop || '-'
    },
    setData (row) {
      if (row.dataCadastro) {
        return moment(row.dataCadastro).format('HH:mm:ss') + ' ' + moment(row.dataCadastro).format('DD/MM/YYYY')
      }
      return '-'
    },
    continuar (object) {
      this.$emit('continuar', { id: object.id })
    },
    remove (object) {
      this.confirmBox(this.$messages.REMOVER_CADASTRO, this.$messages.TITULO_WARNING,
        () => {
          this.$emit('remover', object.id, () => {
            this.changePageNumber()
            this.changePage()
          })
        },
        () => { }
      )
    },
    exporta (object) {
      this.$emit('exportar', object, () => {
        this.changePageNumber()
        this.changePage()
      })
    },
    changePageNumber () {
      if (this.page === 1 || this.cadastros.length > 1) {
        return
      }

      this.page = this.page - 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .pagination {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table__row {
    button {
      i {
        font-size: 14px;
      }
      &.remove {
        color: #CF0021;
        padding: 5px 0;
      }
      &.edit {
        color: #666666;
        padding: 5px 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppListagemCadastros.vue